module.exports = __webpack_public_path__ + "img/yoga.3d37ff5e.jpg";